import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import constants from 'constants';
import actions from 'actions';
import axios from 'axios';

const {
  addAdminUsers,
  addRequestError,
  cleanErrors,
  addErrorsSaga,
  addValidateError,
  setEditUser,
  addAdminAdminDashboardUsers
} = actions;

const {
  LOAD_ADMIN_USERS_SAGA,
  ADMIN_CREATE_USER_SAGA,
  ADMIN_CREATE_USER_SPONSOR_SAGA,
  API_ADMIN_USERS,
  API_ADMIN_USERS_SPONSORS,
  ADMIN_DELETE_USERS_SAGA,
  LOAD_EDIT_USER_SAGA,
  ADMIN_UPDATE_USER_SAGA,
  USER_FILTER_SAGA,
  USER_SPONSOR_FILTER_SAGA,
  LOAD_ADMIN_DASHBOARD_USERS_SAGA,
  API_DASHBOARDS
} = constants;


const apiLoadAdminUsers = (page, query, per_page) => {
  return axios.get(API_ADMIN_USERS, {
    params: {
      page: page,
      per_page: per_page,
      ...query
    }
  })
};

const apiLoadAdminUsersSponsors = (page, query) => {
  return axios.get(API_ADMIN_USERS_SPONSORS, {
    params: {
      page: page,
      per_page: 5,
      ...query
    }
  })
};

const apiCreateUser = (user) => {
  return axios.post(API_ADMIN_USERS, {
    user: user
  })
}

const apiCreateUserSponsor = (user) => {
  return axios.post(API_ADMIN_USERS, {
    user: user
  })
}

const apiDeleteUsers = (user_ids) => {
  return axios.post(API_ADMIN_USERS + '/destroy', {
    user_ids: user_ids
  })
}

const apiGetUser = (user_id) => {
  return axios.get(`${API_ADMIN_USERS}/${user_id}`)
}

const apiAdminUpdateUser = (user) => {
  return axios.put(`${API_ADMIN_USERS}/${user.id}`, {
    user: user
  })
}

const apiLoadAdminDashboardUsers = (query) => (
  axios.get(API_DASHBOARDS, {
    params: {
      ...query,
      page: 0,
    }
  })
);

function* loadAdminUsers({ page = 1, query = {}, per_page = 5}) {
  try {
    const response = yield call(apiLoadAdminUsers, page, query, per_page);
    const users = response.data.users;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminUsers(users, count, page, totalPages, query));

  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* loadAdminUsersSponsors({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminUsersSponsors, page, query);
    const users = response.data.sponsors;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminUsers(users, count, page, totalPages, query));

  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* createUser({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, 'adminCreateUserSponsor');
    if (errors) {
      yield put(addValidateError(ADMIN_CREATE_USER_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_CREATE_USER_SAGA))
    }

    const response = yield call(apiCreateUser, userData);
    const user = response.data.user;
    toast.success('User successfully created!')
    yield put(push('/users/'))
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SAGA, e.response))
  }
}

function* createUserSponsor({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, 'adminCreateUserSponsor');
    if (errors) {
      yield put(addValidateError(ADMIN_CREATE_USER_SPONSOR_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_CREATE_USER_SPONSOR_SAGA))
    }

    const response = yield call(apiCreateUserSponsor, userData);
    const user = response.data.user;
    toast.success('Users Sponsors successfully created!')
    yield put(push('/users_sponsors/'))
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SPONSOR_SAGA, e.response))
  }
}

function* deleteUsers({ user_ids }) {
  const userIds = user_ids;
  try {
    yield call(apiDeleteUsers, userIds);
    toast.success('Users successfully deleted!');
    const query = yield select(state => state.users.adminUsers.query) || {};
    const page = yield select(state => state.users.adminUsers.page) || 1;
    yield call(loadAdminUsers, {page, query});
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SAGA, e.response))
  }
}

function* loadEditUser({ user_id }) {
  try {
    const response = yield call(apiGetUser, user_id);
    const user = response.data.user;
    yield put(setEditUser(user));
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SAGA, e.response))
  }
}

function* adminUpdateUser({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, 'userProfile');
    if (errors) {
      yield put(addValidateError(ADMIN_UPDATE_USER_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_UPDATE_USER_SAGA))
    }

    const response = yield call(apiAdminUpdateUser, userData);
    toast.success('Users successfully updated!');
    yield put(push('/users/'))
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_UPDATE_USER_SAGA, e.response))
  }
}

function* adminUpdateUserSponsor({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, 'userProfile');
    if (errors) {
      yield put(addValidateError(ADMIN_UPDATE_USER_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_UPDATE_USER_SAGA))
    }

    const response = yield call(apiAdminUpdateUser, userData);
    toast.success('Users Sponsors successfully updated!');
    yield put(push('/users_sponsors/'))
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_UPDATE_USER_SAGA, e.response))
  }
}

function* loadAdminAdminDashboardUsers({ query }) {
  try {
    const response = yield call(apiLoadAdminDashboardUsers, query);
    const statistics = response.data.result;
    yield put(addAdminAdminDashboardUsers(statistics));
  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* adminFilterUser({ page = 1,  query = {} , per_page = 5}) {
  yield call(loadAdminUsers, { page, query, per_page });
}

function* adminFilterUserSponsor({ page = 1,  query = {} }) {
  yield call(loadAdminUsersSponsors, { page, query });
}

function* __loadAdminUsers() {
  yield takeEvery(LOAD_ADMIN_USERS_SAGA, loadAdminUsers)
}

function* __adminCreateUserSaga() {
  yield takeLatest(ADMIN_CREATE_USER_SAGA, createUser)
}

function* __adminCreateUserSponsorSaga() {
  yield takeLatest(ADMIN_CREATE_USER_SPONSOR_SAGA, createUserSponsor)
}

function* __adminDeleteUsersSaga() {
  yield takeLatest(ADMIN_DELETE_USERS_SAGA, deleteUsers)
}

function* __loadEditUserSaga() {
  yield takeLatest(LOAD_EDIT_USER_SAGA, loadEditUser)
}

function* __adminUpdateUserSaga() {
  yield takeLatest(ADMIN_UPDATE_USER_SAGA, adminUpdateUser)
}

function* __adminUpdateUserSponsorSaga() {
  yield takeLatest(ADMIN_UPDATE_USER_SAGA, adminUpdateUserSponsor)
}

function* __adminUserFilterSaga() {
  yield takeLatest(USER_FILTER_SAGA, adminFilterUser)
}

function* __adminUserSponsorFilterSaga() {
  yield takeLatest(USER_SPONSOR_FILTER_SAGA, adminFilterUserSponsor)
}

function* __loadAdminAdminDashboardUsersSaga() {
  yield takeLatest(LOAD_ADMIN_DASHBOARD_USERS_SAGA, loadAdminAdminDashboardUsers)
}

export {
  __adminCreateUserSaga,
  __adminCreateUserSponsorSaga,
  __loadAdminUsers,
  __adminDeleteUsersSaga,
  __loadEditUserSaga,
  __adminUpdateUserSaga,
  __adminUpdateUserSponsorSaga,
  __adminUserFilterSaga,
  __adminUserSponsorFilterSaga,
  __loadAdminAdminDashboardUsersSaga
};



/** WEBPACK FOOTER **
 ** ./src/sagas/admin/users.js
 **/